// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

//import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import "@hotwired/turbo-rails"
import Delegate from "ftdomdelegate"

//Rails.start()
Turbolinks.start()

class PageManager {

  constructor(container) {
    this.element         = container;
    this.delegateElement = new Delegate(this.element);
    this.checkboxes      = container.querySelectorAll('.survey__beauty-question-option-container');

    this._attachedListeners();
    this._calcWindowHeight();
  }

  _attachedListeners() {
    let that = this;

    this.delegateElement.on('click', '[data-action="toggle-sidebar"]', this._setEventListener.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-popup"]', this._setEventListener.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-collapse"]', this._toggleCollapse.bind(this));
    this.delegateElement.on('change', '.survey__beauty-question-option-container input', this._openCheckbox.bind(this));
    this.delegateElement.on('click', '[type="submit"], [data-action="loading"]', this._submitForm.bind(this));

    window.addEventListener('resize', function() {
      that._calcWindowHeight();
    });
  }

  // calc window height
  _calcWindowHeight() {
    let root = document.documentElement;
    root.style.setProperty('--inner-height', window.innerHeight + 'px');
  }

  // submit form
  _submitForm(event, target) {
    target.classList.add('is-loading');
  }

  // checkbox manager
  _openCheckbox(event, target) {
    let checkboxContainer = target.closest('.survey__beauty-question-option-container');
    if (checkboxContainer) {
      checkboxContainer.classList.toggle('active');
      if (!checkboxContainer.classList.contains('active')) {
        if (checkboxContainer.querySelector('textarea')) {
          checkboxContainer.querySelector('textarea').value = '';
        }
      }
    }
  }

  _setEventListener(e, target) {
    if (e) e.preventDefault();
    let item = target;

    let sidebar     = document.querySelector('#' + item.getAttribute('aria-controls'));
    let overlay     = document.querySelector('.overlay[data-action="'+item.getAttribute('data-action')+'"]');
    let inputSearch = sidebar.querySelector('.input-search');

    if (sidebar.getAttribute('aria-hidden') === 'true') {
      sidebar.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-controls', item.getAttribute('aria-controls'));

      if(inputSearch){
        setTimeout(function (){
          inputSearch.focus();
        }, 300)
      }
    } else {
      sidebar.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.removeAttribute('aria-controls');
    }
  }

  _toggleCollapse(event, target) {
    let item = target;
    let content = document.querySelector('#' + item.getAttribute('aria-controls'));

    if (item.getAttribute('aria-hidden') === 'true') {
      item.setAttribute('aria-hidden', 'false');
      content.style.height = content.scrollHeight + 'px';
    } else {
      item.setAttribute('aria-hidden', 'true');
      content.style.height = '0px';
    }
  }

}

class AlgoliaManager {

  constructor(container) {
    this.element                  = container;
    this.delegateElement          = new Delegate(this.element);
    this.input                    = container.querySelector('#search');
    this.baseProductContainer     = container.querySelector('[data-content="base-products"]');
    this.addedProductsContainer   = container.querySelector('[data-content="product-added"]');
    this.resultProductsContainer  = container.querySelector('[data-content="search-products"]');
    this.algoliaClient            = algoliasearch('CWW33B0ROX', 'df2850e63cd906c51bd0b4af0f0b722f');

    this._attachedListeners();

    // search base products and display them
    this._searchProduct(true);
  }

  _attachedListeners() {
    let that = this;

    this.delegateElement.on('click', '.survey__footer-button', this._submitForm.bind(this));
    this.delegateElement.on('change', '#prescription', this._changeSubmitButtonLabel.bind(this));


    // click on + product to add it to the list
    this.baseProductContainer.addEventListener('click',function(e){
      e.preventDefault();
      if (e.target.closest('.product-item__image-container')) {
        that._selectProduct(e.target.closest('.product-item'), 'base');
      }
    }, false);

    // click on delete product on the list
    this.addedProductsContainer.addEventListener('click',function(e){
      e.preventDefault();
      if (e.target.closest('.product__button')) {
        that._selectProduct(e.target.closest('.survey__products-added'), 'added');
      }
    }, false);

    // click on add / delete product from the search result
    this.resultProductsContainer.addEventListener('click',function(e){
      e.preventDefault();
      if (e.target.closest('.product__button')) {
        that._selectProduct(e.target.closest('.sidebar__product-container'), 'search');
      }
    }, false);

    // search input
    if (this.input) {
      this.input.addEventListener('keyup', this._debounce(this._searchProduct, 300).bind(this));
    }

  }

  _submitForm(event, target) {
    // check if customer want to receive the prescription by email
    if (document.querySelector('#prescription:checked')) {

      let data = {
        'conseil': document.querySelector('#prescription_advises').value || '',
        'products': [],
        'cartUrl': []
      }

      // get recommended products and add them in a object
      let productRecommended = document.querySelectorAll('[data-content="product-added"] [data-sku]');
      if (productRecommended.length > 0) {
        for (let i = 0; i < productRecommended.length; i++) {
          let product = {
            handle         : productRecommended[i].getAttribute('data-handle'),
            sku            : productRecommended[i].getAttribute('data-sku'),
            id             : productRecommended[i].getAttribute('data-id'),
            image          : productRecommended[i].querySelector('img').getAttribute('src'),
            vendor         : productRecommended[i].querySelector('.product-item__vendor').innerText,
            title          : productRecommended[i].querySelector('.product-item__title').innerText,
            price          : productRecommended[i].querySelector('.product-item__price').innerText,
            variant_title  : productRecommended[i].querySelector('.product-item__variant').innerText
          }
          // push product data
          data.products.push(product);

          // push line_item id
          data.cartUrl.push(product.id+':1');
        }
      }

      data.cartUrl = data.cartUrl.join(',');
      _learnq.push(['track', 'Prescription OMCS', data]);

    }

  }

  _searchProduct(event) {
    let that = this;
    let input = {
      base: true,
      query: 'sku:3664529118416 OR sku:3664529112414 OR sku:3664529133310 OR sku:3664529117525 OR sku:3664529117518 OR sku:3664529118935',
      hits: 6
    };

    if (event !== true) {
      input = {
        base: false,
        query: event.target.value,
        hits: 24
      }
    }

    this.algoliaClient.search([{
      indexName: 'shopify_products',
      query: input.query,
      params: {
        hitsPerPage: input.hits,
        filters: 'vendor:"Oh My Cream Skincare"'
        //filters: 'product_type:Produit OR product_type:"Carte cadeau" OR product_type:"Gift Cards" AND meta.sf_general.masked != 1'
      }
    }], function (err, content) {
      let algoliaResults = content['results'][0];
      //console.log('algoliaResults', algoliaResults)

      // display base products
      if (input.base) {
        that._displayBaseProducts(algoliaResults.hits);

        // get product stored in database and display them
        let products = that._getProductsFromStorage();
        // check if storage contains products
        if (products.length > 0) {
          // search on Algolia these products
          that._searchStoredProducts(products);
        }

      } else {
        that._displayProducts(algoliaResults.hits);
      }
    });
  }

  _displayBaseProducts(products) {
    let productsHTML = '';
    for (let i = 0; i < products.length; i++) {
      productsHTML += '' +
        '<div class="product-item" data-sku="'+products[i].sku+'" data-id="'+parseInt(products[i].objectID)+'" data-handle="'+products[i].handle+'">' +
        '<div class="product-item__wrapper">' +
        '<div class="product-item__image-container">' +
        '<button class="product-item__add"><svg viewBox="0 0 10 10" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 0H4v4H0v2h4v4h2V6h4V4H6V0Z" fill="#fff"/></svg></button>' +
        '<img src="'+products[i].image+'" alt="img">' +
        '</div>' +
        '<div class="product-item__content">' +
        '<p class="product-item__vendor bold">'+products[i].vendor+'</p>' +
        '<p class="product-item__title">'+products[i].title+'</p>' +
        '<div class="product-item__infos">' +
        '<span class="product-item__price">'+products[i].price+' €</span>' +
        '<span class="product-item__separator"></span>' +
        '<span class="product-item__variant">'+products[i].variant_title+'</span>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>';
    }
    this.baseProductContainer.innerHTML = productsHTML;
  }

  _displayProducts(products) {
    let productsHTML = '';
    let hasNoResults = document.querySelector('.sidebar__content-no-results');

    if (products.length > 0) {
      hasNoResults.setAttribute('aria-hidden', 'true')
    } else {
      hasNoResults.setAttribute('aria-hidden', 'false')
    }

    for (let i = 0; i < products.length; i++) {
      let isProductAlreadySelected = this._isProductSelected(products[i].sku);
      productsHTML += '' +
        '<div class="sidebar__product-container" data-sku="'+products[i].sku+'" data-id="'+parseInt(products[i].objectID)+'" data-handle="'+products[i].handle+'" data-added="'+isProductAlreadySelected+'">' +
        '<div class="sidebar__product-wrapper">' +
        '<div class="product-item">' +
        '<div class="product-item__wrapper">' +
        '<div class="product-item__image-container">' +
        '<img src="'+products[i].image+'" alt="img">' +
        '</div>' +
        '<div class="product-item__content">' +
        '<p class="product-item__vendor bold">'+products[i].vendor+'</p>' +
        '<p class="product-item__title">'+products[i].title+'</p>' +
        '<div class="product-item__infos">' +
        '<span class="product-item__price">'+products[i].price+' €</span>' +
        '<span class="product-item__separator"></span>' +
        '<span class="product-item__variant">'+products[i].variant_title+'</span>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '<button class="product__button '+(isProductAlreadySelected ? 'product__button--delete' : '')+'"><svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 3H7v4H3v2h4v4h2V9h4V7H9V3Z" fill="#787878"/></svg>' +
        '<span>Ajouter</span>' +
        '<span>Supprimer</span>' +
        '</button>' +
        '</div>' +
        '</div>';
    }
    this.resultProductsContainer.innerHTML = productsHTML;
  }

  _searchStoredProducts(products) {
    let that = this;
    let filters = products.join(' OR ');
    this.algoliaClient.search([{
      indexName: 'shopify_products',
      query: '',
      params: {
        hitsPerPage: 24,
        filters: filters
      }
    }], function (err, content) {
      let algoliaResults = content['results'][0];
      for (let i = 0; i < algoliaResults.hits.length; i++) {
        let productData = {
          id             : parseInt(algoliaResults.hits[i].objectID),
          sku            : algoliaResults.hits[i].sku,
          handle         : algoliaResults.hits[i].handle,
          image          : algoliaResults.hits[i].image,
          vendor         : algoliaResults.hits[i].vendor,
          title          : algoliaResults.hits[i].title,
          price          : algoliaResults.hits[i].price,
          variant_title  : algoliaResults.hits[i].variant_title
        }

        that._addProductToListing(productData);
      }
    });
  }

  _selectProduct(event, from) {
    let selectedProduct = event.getAttribute('data-id');
    let selectedHandle  = event.getAttribute('data-handle');
    let selectedSku     = event.getAttribute('data-sku');

    let productData = {
      id             : selectedProduct,
      handle         : selectedHandle,
      sku            : selectedSku,
      image          : event.querySelector('img').getAttribute('src'),
      vendor         : event.querySelector('.product-item__vendor').innerText,
      title          : event.querySelector('.product-item__title').innerText,
      price          : event.querySelector('.product-item__price').innerText,
      variant_title  : event.querySelector('.product-item__variant').innerText
    }

    // if selected product comes from search sidebar
    if (from === 'search') {
      let searchedProduct = this.resultProductsContainer.querySelector('[data-sku="'+selectedSku+'"]');
      if (searchedProduct) {
        if (searchedProduct.getAttribute('data-added') === 'true') {
          // remove product from listing
          this._removeProductFromListing(selectedSku);

        } else {
          // add product to listing
          this._addProductToListing(productData);
        }
      }
    }

    // if product is deleted from from listing
    if (from === 'added') {
      // remove product from listing
      this._removeProductFromListing(selectedSku);
    }


    // if product is from base products
    if (from === 'base') {

      if (event.classList.contains('added')) {
        // remove product from listing
        this._removeProductFromListing(selectedSku);

      } else {
        // add product to listing
        this._addProductToListing(productData);
      }

    }

  }

  _addProductToListing(productData) {
    let productsHTML = '' +
      '<div class="survey__products-added" data-sku="'+productData.sku+'" data-id="'+productData.id+'" data-handle="'+productData.handle+'">' +
      '<div class="survey__product-added-wrapper">' +
      '<div class="product-item">' +
      '<div class="product-item__wrapper">' +
      '<div class="product-item__image-container">' +
      '<img src="'+productData.image+'" alt="img">' +
      '</div>' +
      '<div class="product-item__content">' +
      '<p class="product-item__vendor bold">'+productData.vendor+'</p>' +
      '<p class="product-item__title">'+productData.title+'</p>' +
      '<div class="product-item__infos">' +
      '<span class="product-item__price">'+productData.price+'</span>' +
      '<span class="product-item__separator"></span>' +
      '<span class="product-item__variant">'+productData.variant_title+'</span>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '<button class="product__button"><svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 3H7v4H3v2h4v4h2V9h4V7H9V3Z" fill="#ffffff"/></svg>Supprimer</button>' +
      '</div>' +
      '</div>';

    // add product to the listing
    if (this.addedProductsContainer) {
      this.addedProductsContainer.insertAdjacentHTML('beforeend', productsHTML);
    }

    // display red cross on selected product
    if (this.baseProductContainer.querySelector('[data-sku="'+productData.sku+'"]')) {
      this.baseProductContainer.querySelector('[data-sku="'+productData.sku+'"]').classList.add('added');
    }

    // add delete button on search sidebar
    if (this.resultProductsContainer.querySelector('[data-sku="'+productData.sku+'"]')) {
      this.resultProductsContainer.querySelector('[data-sku="'+productData.sku+'"]').setAttribute('data-added', 'true');
      this.resultProductsContainer.querySelector('[data-sku="'+productData.sku+'"] .product__button').classList.add('product__button--delete');
    }

    // store the handle on session
    this._storageManager(productData.sku, 'add');

    this._checkProductsCount();
  }

  _removeProductFromListing(selectedSku) {
    // remove selected product from listening
    if (this.addedProductsContainer.querySelector('[data-sku="'+selectedSku+'"]')) {
      this.addedProductsContainer.querySelector('[data-sku="'+selectedSku+'"]').remove();
    }

    // remove red cross from selected product
    if (this.baseProductContainer.querySelector('[data-sku="'+selectedSku+'"]')) {
      this.baseProductContainer.querySelector('[data-sku="'+selectedSku+'"]').classList.remove('added');
    }

    // remove delete button from search sidebar
    if (this.resultProductsContainer.querySelector('[data-sku="'+selectedSku+'"]')) {
      this.resultProductsContainer.querySelector('[data-sku="'+selectedSku+'"]').setAttribute('data-added', 'false');
      this.resultProductsContainer.querySelector('[data-sku="'+selectedSku+'"] .product__button').classList.remove('product__button--delete');
    }

    // remove selected product from storage
    this._storageManager(selectedSku, 'delete');

    this._checkProductsCount();
  }

  _checkProductsCount() {
    // check how many products there is in the listing to show or hide the text
    let productsCount = this.addedProductsContainer.querySelectorAll('.survey__products-added');
    if (productsCount.length > 0) {
      this.addedProductsContainer.querySelector('.survey__prescription-recommend-products-empty').classList.add('hidden');
    } else {
      this.addedProductsContainer.querySelector('.survey__prescription-recommend-products-empty').classList.remove('hidden');
    }
  }

  _storageManager(productSku, manage) {
    let productsIds = this._getProductsFromStorage();
    let index = productsIds.indexOf('sku:'+productSku);

    if (manage === 'add') {
      // add handle to session if not already exists
      if (index < 0) {
        productsIds.push('sku:'+productSku);
      }
    } else {
      // remove handle from session if exists
      if (index > -1) {
        productsIds.splice(index, 1);
      }
    }

    // remove old inputs
    document.querySelector('.survey__prescriptions-inputs').innerHTML = '';

    // check if array is empty
    if (productsIds.length > 0) {

      // set handles to hidden input in order to save them on Shopify
      let newInputHidden = '';
      for (let i = 0; i < productsIds.length; i++) {
        newInputHidden += '<input multiple="multiple" value="'+productsIds[i].split('sku:')[1]+'" type="hidden" name="prescription[recommended_product_skus][]" id="recommended_product_skus-'+productsIds[i].split('sku:')[1]+'">'
      }

      // inject new input hidden
      document.querySelector('.survey__prescriptions-inputs').innerHTML = newInputHidden;
    }
  }

  _getProductsFromStorage() {
    let productsIds = [];

    // get all inputs hidden with sku and merge them in an array
    let skuInputs = document.querySelectorAll('[name="prescription[recommended_product_skus][]"]');
    if (skuInputs.length > 0) {
      for (let i = 0; i < skuInputs.length; i++) {
        productsIds.push('sku:'+skuInputs[i].value);
      }
    }

    return productsIds;
  }

  _isProductSelected(sku) {
    let products = this._getProductsFromStorage();
    return products.indexOf('sku:' + sku) > -1;
  }

  _debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    }
  }

  _changeSubmitButtonLabel(event, target) {
    let buttonText = document.querySelector('#survey__button-text');
    if (buttonText) {
      if (target.checked) {
        buttonText.innerText = 'Enregistrer et envoyer la prescription par e-mail';
      } else {
        buttonText.innerText = 'Enregistrer';
      }
    }
  }
}

class CodeManager {
  constructor(container) {
    this.codeButtons      = container.querySelectorAll('.survey__code-keyboard-button');
    this.codeBullets      = container.querySelectorAll('.survey__code-bullet');
    this.codeError        = container.querySelector('.survey__code-error');
    this.codeEnter        = container.querySelector('.survey__code-enter');
    this.codePlaceholder  = container.querySelector('.survey__code-placeholder');
    this.deleteCode       = container.querySelector('.survey__code-delete');
    this.redirectUrl      = container.querySelector('.survey__hidden-button');
    this.code             = '7503';
    this.typingCode       = '';

    if (this.codeButtons.length > 0) {
      this._initCode();
    }
  }

  _initCode() {
    let that = this;

    // click on number buttons
    for(let i = 0; i < this.codeButtons.length; i++){
      this.codeButtons[i].addEventListener('click', function (e){
        if(e) e.preventDefault();

        let target  = e.target;
        let number  = target.getAttribute('data-number');

        if(that.typingCode.length < 4){
          that.typingCode += number;

          if(that.codeBullets.length > 0){
            that.codeBullets[that.typingCode.length - 1].classList.add('active');
          }
        }

        if (that.typingCode.length === 4){
          if(that.typingCode !== that.code){
            that.codeError.style.display = 'block';
            that.codeEnter.style.display = 'none';
            that.codePlaceholder.classList.add('error');

            setTimeout(function (){
              that.codeError.style.display = 'none';
              that.codeEnter.style.display = 'block';
              that.codePlaceholder.classList.remove('error');

              for(let j = 0; j < that.codeBullets.length; j++){
                that.codeBullets[j].classList.remove('active');
              }

              that.typingCode = '';
            }, 1000);
          } else {
            that.redirectUrl.click();
          }
        }
      })
    }

    // click on delete button
    this.deleteCode.addEventListener('click', function (e) {
      if (e) e.preventDefault();

      that.typingCode = that.typingCode.slice(0, -1);

      if(that.codeBullets.length > 0){
        that.codeBullets[that.typingCode.length].classList.remove('active');
      }

    })
  }
}

class BeautyProfileManager {
  constructor(container) {
    this.secondarySkinConcerns     = container.querySelectorAll('[name="beauty_profile[secondary_skin_concerns_checkbox]"]');
    this.surveyQuestionLimit       = container.querySelector('.survey__question-limit');
    this.currentSecondarySkinValue = container.querySelector('#beauty_profile_secondary_skin_concerns');

    if (this.currentSecondarySkinValue.value !== "" && this.currentSecondarySkinValue.value !== "null") {
      let currentValues = this.currentSecondarySkinValue.value.split(',');
      if (currentValues.length > 0) {
        for (let i = 0; i < currentValues.length; i++) {
          let currentCheckboxId = currentValues[i].replaceAll(' ', '-').replaceAll("'", '_');
          if (container.querySelector('#' + currentCheckboxId)) {
            container.querySelector('#' + currentCheckboxId).checked = true;
          }
        }
        this._manageSecondarySkinConcern();
      }
    }

    let that = this;
    if (this.secondarySkinConcerns.length > 0) {
      for(let i = 0; i < this.secondarySkinConcerns.length; i++){
        this.secondarySkinConcerns[i].addEventListener('click', function (e) {
          that._manageSecondarySkinConcern();
        });
      }
    }
  }

  _manageSecondarySkinConcern() {
    let itemsSelected      = document.querySelectorAll('[name="beauty_profile[secondary_skin_concerns_checkbox]"]:checked');
    let itemsNotSelected   = document.querySelectorAll('[name="beauty_profile[secondary_skin_concerns_checkbox]"]:not(:checked)');
    let itemSelectedValues = [];

    // disable other inputs when 2 concerns are selected
    if (itemsSelected.length > 1) {
      if (itemsNotSelected.length > 0) {
        for (let i = 0; i < itemsNotSelected.length; i++) {
          itemsNotSelected[i].setAttribute('disabled', 'disabled');
        }
      }
    } else {
      if (itemsNotSelected.length > 0) {
        for (let i = 0; i < itemsNotSelected.length; i++) {
          itemsNotSelected[i].removeAttribute('disabled');
        }
      }
    }

    // join item selected to hidden input
    for (let i = 0; i < itemsSelected.length; i++) {
      itemSelectedValues.push(itemsSelected[i].id);
    }
    let newValues = itemSelectedValues.join(',').replaceAll('-', ' ').replaceAll("_", "'");

    if (document.querySelector('#beauty_profile_secondary_skin_concerns')) {
      document.querySelector('#beauty_profile_secondary_skin_concerns').value = newValues;
    }

    // set number of selected items
    this.surveyQuestionLimit.querySelector('span').innerText = itemsSelected.length;
  }
}

class CustomersManager {
  constructor(container) {
    this.eraseButton    = container.querySelector('.customer__header-remove');
    this.customerName   = container.querySelector('#customer_name');
    this.customerEmail  = container.querySelector('#customer_email');

    let that = this;
    if (this.eraseButton) {
      this.eraseButton.addEventListener('click', function(e) {
        if (e) e.preventDefault();
        if (that.customerName) {
          that.customerName.value = '';
        }
        if (that.customerEmail) {
          that.customerEmail.value = '';
        }
      })
    }
  }
}

(function() {
  new PageManager(document);

  window.addEventListener('code:fired', function(event){
    new CodeManager(document);
  });

  window.addEventListener('prescription:fired', function(event){
    new AlgoliaManager(document);
  });

  window.addEventListener('beauty_profile:fired', function(event){
    new BeautyProfileManager(document);
  });

  window.addEventListener('customers:fired', function(event){
    new CustomersManager(document)
  });

})();
